import React from "react";
import map from "lodash/map";
import submit from "submit-form";
import ManageCategories from "./components/ManageCategories";
import CycleCard from "../all-templates/components/CycleCardCP";
import ConnectedAccountModal from "../../../parts/modals/ConnectedAccountModal";
import copy from "clipboard-copy";
import scriptLoader from "../../../utils/scriptLoader";
import SubHeader from "./components/SubHeader";
import ToolTip from "../../../parts/tooltip";
import SvgIcon from "../../../parts/SvgIcon";
import DropdownIconsCheck from "../../../parts/inputs/dropdown-icons-check";
import useClickOutside from "../../../hooks/useClickOutside";

const StorefrontLinks = ({
  state,
  setState,
  subdomain,
  copyText,
  toolTipText,
}) => {
  const dropdownRef = React.useRef(null);
  useClickOutside(
    dropdownRef,
    () => {
      setState({
        openedStoreDropdown: false,
      });
    },
    state.openedStoreDropdown
  );
  const handleOpen = (e) => {
    e.preventDefault();
    setState({
      openedStoreDropdown: !state.openedStoreDropdown,
    });
  };
  return (
    <details role="list" open ref={dropdownRef}>
      <summary onClick={handleOpen}>
        Storefront Link
        <SvgIcon
          src={
            state.openedStoreDropdown
              ? "/img/new-icons/arrow-square-up.svg"
              : "/img/new-icons/arrow-square-down.svg"
          }
        />
      </summary>
      <ul role="listbox" className={state.openedStoreDropdown ? "opened" : ""}>
        <li>
          <div>
            <p className="p1">Push Storefront</p>
            <p className="p1 text-[--information]">{subdomain}</p>
          </div>
          <ToolTip
            id="img-copy-subdomain"
            body={toolTipText}
            hintClassNames={"img-copy-store"}
          >
            <button
              data-button-type="secondary"
              data-icon
              data-icon-only
              onClick={async () => {
                await copy(subdomain);
                copyText("subdomain");
              }}
            >
              <img src="/img/new-icons/copy.svg" />
            </button>
          </ToolTip>
        </li>
      </ul>
    </details>
  );
};
class View extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    const initialtab = context.locals.query.storeType;

    this.state = {
      showAccountLinkVideo: false,
      showSortCategories: false,
      showSortableMenu: false,
      draggin: false,
      sortableLoaded: false,
      selectedCategoryIndex: null,
      showMostPopular: false,
      toolTipText: "Copy to Clipboard",
      toolTipTextEmail: "Copy to Clipboard",
      toolTipTextPassword: "Copy to Clipboard",
      openedStoreDropdown: false,
      currentTab: initialtab || "programs",
    };
    this.sortable = null;
    this.accountLinkVideo = this.accountLinkVideo.bind(this);
    this.loadDraggable = this.loadDraggable.bind(this);
    this.selectCategory = this.selectCategory.bind(this);
    this.toggleMostPopular = this.toggleMostPopular.bind(this);
    this.deleteCategory = this.deleteCategory.bind(this);
    this.toggleSortable = this.toggleSortable.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.copyText = this.copyText.bind(this);
  }

  componentDidMount() {
    // This flash error will be shown for now to the users trying to access
    // to the store from a mobile device, because the design is not ready yet
    // check athletes.controller.js
    if (window?.innerWidth <= 960) {
      submit("/coaching-portal/athletes", {
        body: {
          flashError: "Responsive store is not available yet.",
        },
      });
    }

    const { activeUser } = this.context.locals;

    if (
      activeUser.pushAccountInfo &&
      !activeUser.pushAccountInfo.accountLinkFinished
    )
      this.setState({ showAccountLinkVideo: true });
    if (this.context.locals.query.status === "draft") return;
    this.loadDraggable();
  }

  componentDidUpdate(prevProps) {
    if (
      this.context.locals.query.status === "draft" &&
      this.sortable !== null
    ) {
      this.sortable.destroy();
      this.sortable = null;
    }

    if (
      this.context.locals.query.status === "published" &&
      this.sortable === null
    ) {
      this.loadDraggable();
    }
  }

  loadDraggable() {
    scriptLoader(
      "https://cdn.jsdelivr.net/npm/sortablejs@latest/Sortable.min.js",
      () => {
        const dragImage = document.createElement("img");
        dragImage.src =
          "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
        this.sortable = new Sortable(document.querySelector("#drag-items"), {
          animation: 350,
          filter: ".button-card",
          setData(dataTransfer) {
            dataTransfer.setDragImage(dragImage, 0, 0);
          },
          onStart: () => {},
          onEnd: ({ oldIndex, newIndex }) => {
            if (oldIndex === newIndex) return;
            const reorderedCycles = [];
            const programs = document.querySelectorAll(".column");
            programs.forEach((program) => {
              reorderedCycles.push(program.id);
            });
            submit("/actions/cycle/store/reorder", {
              method: "POST",
              body: {
                orderedCycles: reorderedCycles,
              },
            });
          },
        });
        this.setState({
          sortableLoaded: true,
        });
      }
    );
  }

  copyText(type) {
    if (type === "email") {
      this.setState({
        toolTipTextEmail: "Copied!",
        toolTipText: "Copy to Clipboard",
        toolTipTextPassword: "Copy to Clipboard",
      });
      setTimeout(() => {
        this.setState({ toolTipTextEmail: "Copy to Clipboard" });
      }, 30000);
    } else if (type === "password") {
      this.setState({
        toolTipTextPassword: "Copied!",
        toolTipTextEmail: "Copy to Clipboard",
        toolTipText: "Copy to Clipboard",
      });
      setTimeout(() => {
        this.setState({ toolTipTextPassword: "Copy to Clipboard" });
      }, 30000);
    } else {
      this.setState({
        toolTipText: "Copied!",
        toolTipTextPassword: "Copy to Clipboard",
        toolTipTextEmail: "Copy to Clipboard",
      });
      setTimeout(() => {
        this.setState({
          toolTipText: "Copy to Clipboard",
        });
      }, 30000);
    }
  }

  accountLinkVideo() {
    const generateLink = () => {
      submit("/actions/user/generate-account-link", {
        method: "POST",
      });
    };

    return (
      <ConnectedAccountModal
        onClose={() => {
          this.setState({ showAccountLinkVideo: false });
        }}
        generateLink={generateLink}
        context={this.context}
      />
    );
  }

  handleSort(direction = "up") {
    try {
      if (direction === "custom") {
        this.openCustomSort();
        return;
      }
      const { programCategories } = this.props;
      const sortedCategories = Array.from(programCategories).sort();
      if (direction !== "up") sortedCategories.reverse();
      const { activeUserToRequest } = this.context.locals;
      submit(`/actions/cycle/store/sort-category`, {
        method: "POST",
        body: {
          sortedCategories,
          activeUserToRequestId: activeUserToRequest._id,
        },
      });
    } catch (error) {
      console.error("Error in handleSort:", error);
    }
  }

  filterCategoryPrograms(programs) {
    const {
      locals: {
        query: { category },
      },
    } = this.context;
    const { showMostPopular, currentTab } = this.state;
    if (!category && !showMostPopular) return programs;
    const isUncategorized = category === "Uncategorized";
    if (isUncategorized && !showMostPopular)
      return programs.filter((program) => !program.category);

    const { mostPopular, mostPopularSingle } = this.props;

    const filtering = showMostPopular
      ? programs.find(
          (program) =>
            program._id ===
            (currentTab === "programs" ? mostPopular : mostPopularSingle)
        )
      : programs.filter((program) => {
          return program.category === category;
        });
    // Avoid errors if no most popular program is found
    return showMostPopular && filtering ? [filtering] : filtering;
  }

  toggleSortable() {
    this.setState({
      showSortableMenu: !this.state.showSortableMenu ? true : false,
    });
  }

  openCustomSort() {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "sort-categories",
      },
    });
  }

  toggleMostPopular() {
    this.setState({
      showMostPopular: !this.state.showMostPopular,
    });
  }

  addCategory() {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "manage-categories",
        newCategory: true,
      },
    });
  }

  selectCategory(selectedCategoryIndex, category) {
    if (this.context.locals.query.selectedCategoryIndex) {
    }

    this.setState({
      showSortableMenu: false,
      selectedCategoryIndex,
      showMostPopular: false,
    });

    submit("/actions/refresh?", {
      method: "GET",
      body: {
        selectedCategoryIndex,
        category,
      },
    });
  }

  deleteCategory(categoryIndex) {
    const confirm = window.confirm("Want to delete it?");
    if (!confirm) return;
    submit(`/actions/cycle/store/manage-category/${categoryIndex}`, {
      method: "GET",
    });
  }

  render() {
    const { locals } = this.context;
    const { programCategories } = this.props;
    const {
      showAccountLinkVideo,
      showSortableMenu,
      showMostPopular,
      toolTipText,
      toolTipTextPassword,
      toolTipTextEmail,
      openedStoreDropdown,
      currentTab,
    } = this.state;
    const {
      storePrograms,
      activeUserToRequest,
      query: { category, selectedCategoryIndex, status },
      activeUser,
    } = locals;

    const { pushAccountInfo } = activeUserToRequest;

    const subdomain = `https://${pushAccountInfo.subdomain}.programs.app` || "";

    let lastPushed = storePrograms.published.length
      ? (new Date() - storePrograms.published[0].modifiedDate) /
        (1000 * 3600 * 24)
      : null;
    if (lastPushed)
      lastPushed = lastPushed < 1 ? "less than 1 day" : lastPushed.toFixed();

    const filteredPrograms = this.filterCategoryPrograms(
      storePrograms[locals.query.status || "published"].filter(
        (program) =>
          (currentTab === "programs" && !program.storeType) ||
          program.storeType === currentTab
      )
    );

    const isOnboardingStarting =
      !!locals.userByEmail &&
      locals.userByEmail.token &&
      locals.userByEmail.setup !== "finished"
        ? true
        : false;

    const hasAdminPermission = activeUser?.organizationUserStatus
      ? locals?.organizationRoleName &&
        (locals.organizationRoleName === "Owner" ||
          locals.organizationRoleName === "Admin")
      : true;

    return (
      <main className="coaching-store">
        {showAccountLinkVideo && this.accountLinkVideo()}
        <header>
          <hgroup>
            <div className="toggle-options">
              <a
                role="button"
                data-button-type={
                  status === "published" || status === undefined
                    ? "outline"
                    : "text-white"
                }
                href="/actions/refresh?status=published"
              >
                <span>Published</span>
              </a>
              <a
                role="button"
                data-button-type={status === "draft" ? "outline" : "text-white"}
                href="/coaching-portal/store?status=draft"
              >
                <span>Draft</span>
              </a>
            </div>
            <nav role="tablist">
              <a
                aria-current={currentTab === "programs" ? true : undefined}
                onClick={() => {
                  this.setState({ currentTab: "programs" });
                }}
              >
                Programs (
                {
                  storePrograms[locals.query.status || "published"].filter(
                    (program) =>
                      !program.storeType || program.storeType === "programs"
                  ).length
                }
                )
              </a>
              {/* <a
                aria-current={currentTab === "teams" ? true : undefined}
                onClick={() => {
                  this.setState({ currentTab: "teams" });
                }}
              >
                Teams
              </a> */}
              <a
                aria-current={
                  currentTab === "single-workout" ? true : undefined
                }
                onClick={() => {
                  this.setState({ currentTab: "single-workout" });
                }}
              >
                Single Workouts (
                {
                  storePrograms[locals.query.status || "published"].filter(
                    (program) => program.storeType === "single-workout"
                  ).length
                }
                )
              </a>
            </nav>
            <a
              role="button"
              data-button-type={"outline"}
              href="/coaching-portal/store/program-metrics"
              className="program-metrics mobile-hidden"
            >
              <SvgIcon src={`/img/new-icons/vuesax-linear-chart.svg`} />
              <span>Program Metrics</span>
            </a>
            <StorefrontLinks
              state={this.state}
              setState={(toset) => this.setState(toset)}
              subdomain={subdomain}
              copyText={this.copyText}
              toolTipText={toolTipText}
            />
            <DropdownIconsCheck
              items={[
                {
                  title: "A-Z",
                  alt: "Sort",
                  id: "up",
                },
                {
                  title: "Z-A",
                  alt: "Sort",
                  id: "down",
                },
                {
                  title: "Custom",
                  alt: "Sort",
                  id: "custom",
                },
              ]}
              action={this.handleSort}
              title="Sort"
              checkedPath="/img/new-icons/check.svg"
              unCheckedPath="/img/new-icons/uncheck.svg"
            />
            {hasAdminPermission && (
              <a
                href="/coaching-portal/settings/branding"
                role="button"
                data-button-type="outline"
              >
                Edit branding settings
              </a>
            )}

            <a
              role="button"
              data-button-type="primary"
              href={`/actions/refresh/?modal[type]=build-step-one&cycleType=new&isSubscription=true&storeType=${currentTab}`}
            >
              <img alt="add" src="/img/new-icons/add.svg" />
              Add New
            </a>
          </hgroup>
          <SubHeader
            lastPushed={lastPushed}
            storePrograms={storePrograms}
            programCategories={programCategories}
            showSortableMenu={showSortableMenu}
            showMostPopular={showMostPopular}
            selectedCategoryIndex={selectedCategoryIndex}
            toggleSortable={this.toggleSortable}
            selectCategory={this.selectCategory}
            handleSort={this.handleSort}
            openCustomSort={this.openCustomSort}
            toggleMostPopular={this.toggleMostPopular}
            addCategory={this.addCategory}
          />
        </header>

        {category &&
        (selectedCategoryIndex || typeof selectedCategoryIndex === "number") &&
        !this.state.showMostPopular ? (
          <ManageCategories
            category={category}
            selectedCategoryIndex={selectedCategoryIndex}
            filteredProgramsLength={filteredPrograms.length}
            deleteCategory={this.deleteCategory}
            currentTab={currentTab}
          />
        ) : null}
        <section>
          <div
            className={`columns ${status === "draft" ? "draft" : ""}`}
            id="drag-items"
          >
            {filteredPrograms.length > 0 ? (
              map(filteredPrograms, (cycle, cardIndex) => {
                return (
                  <CycleCard
                    key={cycle._id}
                    cycle={cycle}
                    cardIndex={cardIndex}
                    isOwnCycle={cycle.owner === locals.activeUserToRequest._id}
                  />
                );
              })
            ) : !!category ? (
              <div className="no-programs-section">
                <h3 className="pb-4">
                  Seems like you have not added any{" "}
                  {currentTab === "programs" ? "programs" : "workouts"} to this
                  category
                </h3>
                <p className="p2 pb-9">
                  Add a {currentTab === "programs" ? "program" : "workout"}!
                </p>
                <button
                  data-button-type="primary"
                  onClick={() => {
                    submit("/actions/refresh?", {
                      method: "GET",
                      body: {
                        "modal[type]": "manage-categories",
                        storeType: currentTab,
                      },
                    });
                  }}
                >
                  <img alt="add" src="/img/new-icons/add.svg" />
                  Manage Category
                </button>
              </div>
            ) : (
              <div className="no-programs-section">
                <h3 className="pb-4">
                  Seems like you have no{" "}
                  {currentTab === "programs" ? "programs" : "workouts"}{" "}
                  {status === "draft" ? "drafted" : "published"}
                </h3>
                <p className="p2 pb-9">
                  {status === "draft" ? "Create" : "Publish"} a new{" "}
                  {currentTab === "programs" ? "program" : "workout"}!
                </p>
                <a
                  role="button"
                  data-button-type="primary"
                  href={`/actions/refresh/?modal[type]=build-step-one&cycleType=new&isSubscription=true&storeType=${currentTab}`}
                >
                  <img alt="add" src="/img/new-icons/add.svg" />
                  Add New
                </a>
              </div>
            )}
          </div>
          <input
            type="radio"
            name="more"
            id="more-reset"
            style={{ display: "none" }}
          />
        </section>
      </main>
    );
  }
}

export default View;
